<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
    {{ item }} -->
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.name }}
        <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
      </b-card-header>
      <b-card-body class="py-0">
        <div>
          <b-row>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Code" label-for="id" label-cols="12">
                <b-input-group>
                  <b-form-input type="text" v-model="item.id" placeholder="Enter code" size="sm" trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="item.id = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Description" label-for="name" label-cols="12">
                <b-input-group>
                  <b-form-input type="text" v-model="item.name" placeholder="Enter description" size="sm"></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="item.name = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="idselected">
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Created At" label-for="created_at" label-cols="12">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help="" locale="en-GB"
                      :disabled="true"></b-form-datepicker>
                  </b-input-group-prepend>
                  <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                    autocomplete="off" :disabled="true"></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="item.created_at = null" :disabled="true">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Created By" label-for="created_by" label-cols="12">
                <b-input-group>
                  <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                    :disabled="true"></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''" :disabled="true">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help="" locale="en-GB"
                      :disabled="true"></b-form-datepicker>
                  </b-input-group-prepend>
                  <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                    autocomplete="off" :disabled="true"></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null" :disabled="true">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                <b-input-group>
                  <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                    :disabled="true"></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''" :disabled="true">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="nopadding mt-2">
        <b-row no-gutters>
          <b-col cols="auto" class="text-left mr-3">
            <b-button squared size="sm" variant="primary" @click="saveit" v-if="user.rolename == 'admin'">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
          <b-col class="text-left my-auto">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>

    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "NLCodeEdit",

  data() {
    return {
      busy: false,

      item: { id: null, name: null },
      options: {
        title: "N/L Code",
        icon: "fa fa-exchange",
      },
    };
  },
  methods: {
    /*  async loadDDL() {
      console.log("loadDDL");
      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query salesgroups {
              salesgroups {
                id
                label: id
              }
            }
          `,
        });
        this.salesgroups_options = response.data.salesgroups;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    }, */
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query nlcodes($id: String) {
              nlcodes(id: $id) {
                id
                name
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.nlcodes.length > 0) {
          this.item = response.data.nlcodes[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let variables = { rows: [this.cleanit(this.item)] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation nlcodes_save($rows: [NLCode_input], $dateformat: String) {
              nlcodes_save(rows: $rows, dateformat: $dateformat) {
                id
                name
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>